export default __webpack_public_path__ + "static/media/rickroll.c60f84db.gif";